import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    type: 'secondParty',
    isLoading: false,
    list: [],
    activeList: {},
    activeProviders: [],
    collection: {}
}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}
